import { render, staticRenderFns } from "./AddNode.vue?vue&type=template&id=4c354bb6&"
import script from "./AddNode.vue?vue&type=script&lang=js&"
export * from "./AddNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports